module.exports = __webpack_public_path__ + "static/media/12.e0426e80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/12.jpg
// module id = 582
// module chunks = 0